/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// Block programmatic cart opens (multi-buy modal calls .click() — isTrusted=false).
// Genuine user taps (isTrusted=true) still open the cart normally.
document.addEventListener('click', function(e) {
  if (e.target.closest('[data-action="toggle-mini-cart"]') && !e.isTrusted) {
    e.stopImmediatePropagation();
  }
}, true);

// Measure header height once at page load; CSS uses var(--mobile-header-height) to offset cart content.
// Use the LAST .shopify-section-group-header-group (the nav bar, not the announcement bar above it).
(function() {
  function measure() {
    var hgs = document.querySelectorAll('.shopify-section-group-header-group');
    var hg = hgs.length > 0 ? hgs[hgs.length - 1] : null;
    if (hg) {
      document.documentElement.style.setProperty('--mobile-header-height', hg.offsetHeight + 'px');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', measure);
  } else {
    measure();
  }
})();

// Click-to-play hero video (home page "Slideshow Video" section) — video no longer autoplays on load
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.slideshow__video-play');
  if (!btn) return;
  var wrapper = btn.closest('.slideshow__video-wrapper');
  var video = wrapper ? wrapper.querySelector('video') : null;
  if (!video) return;
  wrapper.classList.add('is-playing');
  video.play();
});

// Add aria-label on WhatsApp icon

// ── Meteor mega menu — collapsible category groups ──
(function () {
  'use strict';

  function expandBody(menu, body, chevron) {
    if (body.classList.contains('mm-open')) return;

    // Accordion: collapse any other open section in the same menu first
    menu.querySelectorAll('.mm-col-body.mm-open').forEach(function (otherBody) {
      var otherHeader = otherBody.previousElementSibling;
      var otherChevron = otherHeader ? otherHeader.querySelector('.mm-chevron') : null;
      collapseBody(otherBody, otherChevron);
    });

    body.classList.add('mm-open');
    body.style.display = 'block';
    var h = body.scrollHeight;
    body.style.maxHeight = '0';
    body.style.overflow = 'hidden';
    body.style.transition = 'max-height 0.28s ease';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        body.style.maxHeight = h + 'px';
      });
    });
    if (chevron) chevron.classList.add('mm-open');
    body.addEventListener('transitionend', function handler() {
      body.removeEventListener('transitionend', handler);
      body.style.maxHeight = '';
      body.style.overflow = '';
      body.style.transition = '';
    });
  }

  function collapseBody(body, chevron) {
    if (!body.classList.contains('mm-open')) return;
    body.classList.remove('mm-open');
    if (chevron) chevron.classList.remove('mm-open');
    body.style.maxHeight = body.scrollHeight + 'px';
    body.style.overflow = 'hidden';
    body.style.transition = 'max-height 0.22s ease';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        body.style.maxHeight = '0';
      });
    });
    body.addEventListener('transitionend', function handler() {
      body.removeEventListener('transitionend', handler);
      if (!body.classList.contains('mm-open')) {
        body.style.display = 'none';
      }
      body.style.maxHeight = '';
      body.style.overflow = '';
      body.style.transition = '';
    });
  }

  function resetMenu(menu) {
    menu.querySelectorAll('.mm-col-body').forEach(function (body) {
      var header = body.previousElementSibling;
      var chevron = header ? header.querySelector('.mm-chevron') : null;
      body.classList.remove('mm-open');
      body.style.display = 'none';
      body.style.maxHeight = '';
      body.style.overflow = '';
      body.style.transition = '';
      if (chevron) chevron.classList.remove('mm-open');
    });
  }

  function initMenu(menu) {
    if (menu.dataset.mmInit) return;
    menu.dataset.mmInit = '1';

    var titles = Array.from(menu.querySelectorAll('.m-title'));

    titles.forEach(function (title) {
      if (title.dataset.mmInit) return;
      title.dataset.mmInit = '1';

      var parent = title.parentElement;

      // Find the FIRST sibling that contains actual sub-links (.m-link elements).
      // Stops at the next .m-title or .mm-col-header so we don't cross into another group.
      // Separators and decorative elements that contain no links are ignored.
      var subContainer = null;
      var sib = title.nextElementSibling;
      while (sib && !sib.classList.contains('m-title') && !sib.classList.contains('mm-col-header')) {
        if (sib.querySelector && sib.querySelector('.m-link')) {
          subContainer = sib;
          break;
        }
        sib = sib.nextElementSibling;
      }

      // Build header wrapper: title always gets a header div
      var header = document.createElement('div');
      header.className = 'mm-col-header';
      parent.insertBefore(header, title);
      header.appendChild(title);

      // No actual sub-links found → no chevron, no collapsible body
      if (!subContainer) return;

      var chevron = document.createElement('button');
      chevron.type = 'button';
      chevron.className = 'mm-chevron';
      chevron.setAttribute('aria-label', 'Toggle category');
      chevron.innerHTML =
        '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M3 5.5L7.5 10L12 5.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>';
      header.appendChild(chevron);

      // Wrap ONLY the sub-link container in a collapsible body div.
      // Separators and other Meteor elements are left in place.
      var body = document.createElement('div');
      body.className = 'mm-col-body';
      body.style.display = 'none';
      parent.insertBefore(body, subContainer);
      body.appendChild(subContainer);

      chevron.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (body.classList.contains('mm-open')) {
          collapseBody(body, chevron);
        } else {
          expandBody(menu, body, chevron);
        }
      });
    });

    // Reset collapsed sections when Meteor hides the menu via attribute changes
    new MutationObserver(function () {
      var hidden =
        menu.getAttribute('aria-hidden') === 'true' ||
        menu.style.display === 'none' ||
        menu.style.visibility === 'hidden';
      if (hidden) resetMenu(menu);
    }).observe(menu, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'style', 'class']
    });
  }

  function initAll() {
    document.querySelectorAll('.meteor-menu').forEach(initMenu);
  }

  function tryInit(attempt) {
    if (document.querySelectorAll('.meteor-menu').length) {
      initAll();
    } else if (attempt < 6) {
      setTimeout(function () { tryInit(attempt + 1); }, 400);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { tryInit(0); });
  } else {
    tryInit(0);
  }

  // Also catch menus injected late into the DOM
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('meteor-menu')) initMenu(node);
        if (node.querySelectorAll) node.querySelectorAll('.meteor-menu').forEach(initMenu);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
}());

// Desktop navigation overlay — darkens page when a nav dropdown is open
(function () {
  function init() {
    if (!document.body) { setTimeout(init, 50); return; }
    if (window.innerWidth <= 768) return;

    var overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:400;pointer-events:none;display:none;';
    document.body.appendChild(overlay);

    function isMeteorOpen() {
      var menus = document.querySelectorAll('.meteor-menu');
      for (var i = 0; i < menus.length; i++) {
        var m = menus[i];
        if (m.offsetHeight === 0) continue;
        var cs = window.getComputedStyle(m);
        if (cs.visibility === 'hidden') continue;
        if (parseFloat(cs.opacity) < 0.1) continue;
        return true;
      }
      return false;
    }

    var wasOpen = false;
    function tick() {
      var anyOpen = isMeteorOpen() ||
        !!document.querySelector('.nav-bar__item.is-dropdown-open') ||
        !!document.querySelector('.nav-dropdown[aria-hidden="false"]');
      if (anyOpen !== wasOpen) {
        wasOpen = anyOpen;
        overlay.style.display = anyOpen ? 'block' : 'none';
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  init();
}());

/* ------------------------------------------------------------------
   Add to cart feedback. Added 16.9.2026.

   Two things, both driven by the cart count in the header:

   1. The badge turns brand orange (#e7704b) as soon as the cart holds
      anything, and goes back to the theme black when the cart is empty.
   2. On every increase the count pops and the cart icon wobbles for about
      half a second, so the customer gets a clear signal that the product
      landed in the cart instead of only a silent change of digit.

   It watches the number itself rather than listening for an add-to-cart
   event, because this theme has several add paths and they do not behave
   the same way: the product form and the quick add cards dispatch
   "product:added", while multi-buy-table.js writes the new number straight
   into the badge and fires nothing. Watching the number covers every path,
   apps included.

   The few CSS rules it needs are injected from here, so the whole feature
   lives in one block. To remove: delete this block.
   ------------------------------------------------------------------ */
(function () {
  var CSS = [
    '#cart-icon-bubble.dd-has-items .header__cart-count{background:#e7704b}',
    '#cart-icon-bubble.dd-added .header__cart-count{animation:ddCartCountPop 450ms ease-out}',
    '#cart-icon-bubble.dd-added .header__cart-icon{animation:ddCartShake 550ms ease-in-out}',
    '@keyframes ddCartCountPop{0%{transform:scale(1)}30%{transform:scale(1.7)}55%{transform:scale(.88)}100%{transform:scale(1)}}',
    '@keyframes ddCartShake{0%,100%{transform:rotate(0)}15%{transform:rotate(-14deg)}35%{transform:rotate(11deg)}55%{transform:rotate(-7deg)}75%{transform:rotate(4deg)}}',
    '@media (prefers-reduced-motion:reduce){#cart-icon-bubble.dd-added .header__cart-count,#cart-icon-bubble.dd-added .header__cart-icon{animation:none}}'
  ].join('');

  var style = document.createElement('style');
  style.id = 'dd-cart-added-feedback';
  style.textContent = CSS;
  document.head.appendChild(style);

  var watched = null;
  var observer = null;
  var lastCount = 0;
  var clearTimer = null;

  function readCount(bubble) {
    var el = bubble.querySelector('.header__cart-count');
    if (!el) return null;
    var n = parseInt((el.textContent || '').replace(/[^0-9]/g, ''), 10);
    return isNaN(n) ? null : n;
  }

  function paint(bubble, count) {
    if (count > 0) {
      bubble.classList.add('dd-has-items');
    } else {
      bubble.classList.remove('dd-has-items');
    }
  }

  function play(bubble) {
    // Restart cleanly when two products are added in quick succession.
    bubble.classList.remove('dd-added');
    void bubble.offsetWidth;
    bubble.classList.add('dd-added');

    clearTimeout(clearTimer);
    clearTimer = setTimeout(function () {
      bubble.classList.remove('dd-added');
    }, 700);
  }

  function attach() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || bubble === watched) return;

    if (observer) observer.disconnect();
    watched = bubble;

    var current = readCount(bubble);
    if (current === null) {
      current = window.theme && typeof window.theme.cartCount === 'number' ? window.theme.cartCount : 0;
    }
    lastCount = current;
    paint(bubble, current);

    observer = new MutationObserver(function () {
      var now = readCount(bubble);
      if (now === null) return;
      paint(bubble, now);
      if (now > lastCount) play(bubble);
      lastCount = now;
    });

    // Attributes are deliberately not observed, so the classes this puts on
    // the bubble cannot re-trigger the observer.
    observer.observe(bubble, { childList: true, characterData: true, subtree: true });
  }

  function start() {
    attach();
    // The header can be replaced wholesale by a cart re-render or by the
    // theme editor, which would leave the observer watching a detached node.
    document.addEventListener('cart:rerendered', attach);
    document.addEventListener('product:added', attach);
    document.addEventListener('shopify:section:load', attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}());

/* Mobile menu (Meteor): opening a sub-menu kept the panel's scroll position,
   so a sub-menu opened from low in a long list (e.g. Implants > Sirona CEREC)
   slid in above the screen, under the header, and the tap looked dead.
   Scroll the panel back to the top whenever a sub-menu opens (19.9.2026). */
(function () {
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('.mobile-menu__panel a[aria-haspopup="true"]');
    if (!link) return;
    var panel = link.closest('.mobile-menu__panel');
    var toTop = function () { panel.scrollTop = 0; };
    setTimeout(toTop, 0);
    setTimeout(toTop, 400); // again after Meteor's slide-in animation
  }, true);
}());
